import React from 'react';
import { useContent } from '../context/ContentContext';
import Hero from '../components/Hero';
import SplitIntro from '../components/SplitIntro';
import FeaturedSection from '../components/FeaturedSection';
import ShopSection from '../components/ShopSection';
import JournalSection from '../components/JournalSection';
import PortfolioGrid from '../components/PortfolioGrid';
import Footer from '../components/Footer';
import ReviewsTab from '../components/ReviewsTab';
import './Home.css';

const Home = () => {
  const { content } = useContent();

  return (
    <div className="home-page">
      <Hero />
      <SplitIntro />
      <FeaturedSection 
        title={content.featured.alps.title}
        description={content.featured.alps.description}
        image={content.featured.alps.image}
        align="left"
        linkText="SEE MORE"
      />
      <FeaturedSection 
        title={content.featured.iceland.title}
        description={content.featured.iceland.description}
        image={content.featured.iceland.image}
        align="right"
        linkText="SEE MORE"
      />
      <ShopSection />
      <JournalSection />
      <PortfolioGrid limit={6} />
      <Footer />
      <ReviewsTab />
    </div>
  );
};

export default Home;

